import {StyleSheet, View} from 'react-native';
import {Text} from 'react-native-paper';
import {RootTabScreenProps} from "../../../../types";
import React, {useEffect} from "react";
import {useDataStore} from "../../../store/data/dataStore";
import {useIsFocused} from "@react-navigation/native";

export default function EmployeeReportsScreen({ navigation }: RootTabScreenProps<'EmployeeReportsScreen'>) {

  const {setTrackingMenuId} = useDataStore();

  const isFocused = useIsFocused();

  useEffect(() => {
    console.log('EmployeeReportsScreen[Loading]');
    if (isFocused) {
      console.log('EmployeeReportsScreen[Focused]');
      setTrackingMenuId('mytimeoff-reports');
    }

    return () => {
      console.log('EmployeeReportsScreen[Unloading]');
    }

  }, [isFocused]);

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Reports Screen</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
  },
});
